/* ==========================================================================
   Olfatto v2 — deriva del frasco

   Parallax de verdad: el frasco viaja mas lento que el texto que lo
   acompana. En una pagina blanca no hay fondo que mover, asi que la unica
   fuente posible de profundidad es que dos cosas recorran la pantalla a
   distinta velocidad. Sin eso el scroll suavizado de Lenis es
   imperceptible: suaviza la pagina entera y no queda nada contra que
   percibirlo.

   POR QUE NO VA CON ANIMACIONES POR SCROLL
   Ni la forma declarativa ni la API sirven en Chrome 151. Medido el
   2026-08-25 sobre esta tienda:
   · `animation-timeline: view()` en CSS: el computed style es correcto, la
     animacion se crea y el ViewTimeline se construye con el sujeto bueno,
     pero currentTime se queda en null y nunca aplica. Igual con
     `view-timeline-name` en un ancestro, con longhands + duration:auto, y
     en un iframe limpio con el CSS minimo.
   · `new ViewTimeline({subject})`: parece funcionar porque al leerlo recien
     construido da un valor plausible (77.4%), pero se CONGELA ahi. El mismo
     objeto devolvia 121.059% en dos posiciones de scroll distintas, y las
     animaciones atadas a el quedaban con startTime null y sin aplicar
     transform. Se probo con element.animate({timeline}), con y sin
     rangeStart/rangeEnd, y con new Animation(new KeyframeEffect(...), tl)
     mas play() explicito. Los tres, igual.
   · CSS.supports('animation-timeline','view()') devuelve true y miente:
     solo prueba el parser.

   Asi que se resuelve leyendo el scroll, que es lo que CLAUDE.md ya
   contemplaba. No abre un loop permanente: pide un requestAnimationFrame
   por frame solo mientras hay scroll, y solo toca los elementos que un
   IntersectionObserver dice que estan cerca de la ventana. Lecturas y
   escrituras van separadas para no provocar layout thrashing.

   Escucha el evento nativo de scroll y no la API de Lenis a proposito:
   Lenis entra por un import dinamico y puede no existir todavia cuando esto
   arranca. Lenis mueve el scroll real, asi que el evento nativo sirve para
   los dos casos.

   Solo toca transform. Cero CLS: no altera el layout y el aspect-ratio del
   marco ya reserva el hueco. Si esto falla, el frasco se queda quieto y la
   pagina se ve completa: la deriva es mejora, no requisito.
   ========================================================================== */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var items = [];
  var visibles = [];
  var io = null;
  var pedido = false;

  /* La dosis se mide contra el aire que el frasco tiene encima dentro de su
     marco: ocupa el 70% de una celda 3/4, asi que sobran 128px en desktop y
     unos 67px en movil, donde la celda mide ~169px de ancho. 14px de
     recorrido caben con holgura; en movil se baja a 8 para mantener la
     misma proporcion de aire y que el frasco no se salga del marco. */
  function dosis() {
    return window.matchMedia('(min-width: 750px)').matches ? 14 : 8;
  }

  function construir() {
    if (io) io.disconnect();
    items = [];
    visibles = [];

    document.querySelectorAll('.olf-card__img').forEach(function (el) {
      if (el.parentElement) {
        items.push({ el: el, sujeto: el.parentElement, grande: false });
      }
    });

    /* En la ficha el marco es position:sticky en >=990px, asi que no se
       mueve respecto a la ventana y no sirve como referencia. El sujeto es
       la celda estirada, que si recorre la pagina entera mientras se lee la
       piramide. Es donde mas se siente: un objeto grande y mucho scroll. */
    document.querySelectorAll('.olf-pdp__img').forEach(function (el) {
      var media = el.closest('.olf-pdp__media');
      if (media) items.push({ el: el, sujeto: media, grande: true });
    });

    if (!items.length) return;

    io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          var it = e.target.olfItem;
          if (!it) return;
          var i = visibles.indexOf(it);
          if (e.isIntersecting) {
            if (i === -1) visibles.push(it);
          } else if (i !== -1) {
            visibles.splice(i, 1);
          }
        });
        pintar();
      },
      { rootMargin: '15% 0px 15% 0px', threshold: 0 }
    );

    items.forEach(function (it) {
      it.sujeto.olfItem = it;
      io.observe(it.sujeto);
    });
  }

  function pintar() {
    pedido = false;
    if (!visibles.length) return;

    var vh = window.innerHeight;
    var d = dosis();

    /* todas las lecturas primero */
    var medidas = visibles.map(function (it) {
      return { it: it, r: it.sujeto.getBoundingClientRect() };
    });

    /* y despues todas las escrituras */
    medidas.forEach(function (m) {
      /* 0 cuando el sujeto acaba de asomar por abajo, 1 cuando acaba de
         salir por arriba. El mismo recorrido que `cover` de las animaciones
         por scroll, calculado a mano. */
      var p = (vh - m.r.top) / (vh + m.r.height);
      if (p < 0) p = 0;
      else if (p > 1) p = 1;

      var a = m.it.grande ? d + 6 : d;
      m.it.el.style.transform = 'translateY(' + (a - 2 * a * p).toFixed(2) + 'px)';
    });
  }

  function alScrollear() {
    if (pedido) return;
    pedido = true;
    requestAnimationFrame(pintar);
  }

  function arrancar() {
    construir();
    pintar();
  }

  if (document.readyState !== 'loading') arrancar();
  else
    document.addEventListener('DOMContentLoaded', function () {
      arrancar();
    });

  window.addEventListener('scroll', alScrollear, { passive: true });
  window.addEventListener('resize', arrancar, { passive: true });

  /* el editor de temas recarga secciones sin recargar la pagina */
  document.addEventListener('shopify:section:load', function () {
    arrancar();
  });
})();
